import useError from '@/hooks/useError';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';

const useSearchPartner = (
  { showError = true }: { showError?: boolean } = { showError: true }
) => {
  const addError = useError();
  const [, makeRequest] = useImperativeRequestWrapper('lpVillage');

  const getSinglePartner = async (searchName) => {
    const queryString = new URLSearchParams({
      name: `${searchName}`,
      pageSize: '2',
    }).toString();
    const { error, data } = await makeRequest({
      path: `/admin/partners?${queryString}`,
      method: 'get',
    });

    if (error || (data?.items || []).length !== 1) {
      error && showError && addError(error);

      return { success: false, size: (data?.items || []).length };
    }

    return { success: true, partner: data.items[0] };
  };

  const getMultiplePartner = async (searchName) => {
    const queryString = new URLSearchParams({
      name: `${searchName}`,
      pageSize: '15',
    }).toString();

    const { error, data } = await makeRequest({
      path: `/admin/partners?${queryString}`,
      method: 'get',
    });
    if (error || (data?.items || []).length === 0) {
      error && showError && addError(error);

      return { success: false, size: (data?.items || []).length };
    }

    return { success: true, partners: data.items };
  };

  const getPartnerById = async (partnerId: string) => {
    const { error, data } = await makeRequest({
      path: `/admin/partners/${partnerId}`,
      method: 'get',
    });

    if (error || !data) {
      error && showError && addError(error);

      return { success: false, partner: null };
    }

    // Handle different API response structures (data.partner or data directly)
    const partnerData = data?.partner || data;

    return { success: true, partner: partnerData };
  };

  return { getSinglePartner, getMultiplePartner, getPartnerById };
};

export default useSearchPartner;
